export default {
  has_mouse: false,
  preload: [],
  classes: {},
  toggles: [],
  alert: false,
}
